;(function () {
  window.initPageLayout = function () {
    $(".overlay-label.account").click(function (e) {
      var o
      o = $(e.target).closest(".overlay")
      if (!$(o).hasClass("open")) {
        $(o).addClass("open")
        e.stopPropagation()
        $(document).one("click", function () {
          return $(o).removeClass("open")
        })
        return $(o)
          .find(".menu")
          .click(function (e) {
            return e.stopPropagation()
          })
      }
    })
    $(".overlay-label.clients").click(function (e) {
      var o
      o = $(e.target).closest(".overlay")
      if (!$(o).hasClass("open")) {
        $(o).addClass("open")
        e.stopPropagation()
        $(document).one("click", function () {
          return $(o).removeClass("open")
        })
        return $(o)
          .find(".menu")
          .click(function (e) {
            return e.stopPropagation()
          })
      }
    })
    return $(".sub.menu .search").click(function (e) {
      if (!$(".sub.menu .search").hasClass("open")) {
        $(".sub.menu .search").addClass("open")
        e.stopPropagation()
        $(document).one("click", function () {
          return $(".sub.menu .search").removeClass("open")
        })
        return $(".sub.menu .search").click(function (e) {
          return e.stopPropagation()
        })
      }
    })
  }
}).call(this)
